import { lazy, Suspense } from 'react';
import { Outlet, type RouteObject } from 'react-router';

import { CONFIG } from 'src/global-config';
import { ClientLayout } from 'src/layouts/client/layout';

import { SplashScreen } from 'src/components/loading-screen';

import { ClientAuthGuard } from 'src/auth/guard/client-auth-guard';

const ResetPasswordPage = lazy(() => import('src/pages/client/reset-password/index'));
const ChangePhonePage = lazy(() => import('src/pages/client/change-phone/index'));
const ChangePhoneSuccessPage = lazy(() => import('src/pages/client/change-phone/success/index'));
const FeedbackPage = lazy(() => import('src/pages/client/feedback/index'));
const HelpPage = lazy(() => import('src/pages/client/help-center/index'));
const ResetPasswordSuccessPage = lazy(
  () => import('src/pages/client/reset-password/success/index')
);

const wrapWithGuard = (el: React.ReactNode) =>
  CONFIG.auth.skip ? el : <ClientAuthGuard>{el}</ClientAuthGuard>;

export const clientRoutes: RouteObject[] = [
  {
    path: 'client',
    element: wrapWithGuard(
      <ClientLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </ClientLayout>
    ),
    children: [
      {
        path: 'reset-password',
        children: [
          {
            index: true,
            element: <ResetPasswordPage />,
          },
          {
            path: 'success',
            element: <ResetPasswordSuccessPage />,
          },
        ],
      },
      {
        path: 'change-phone',
        children: [
          {
            index: true,
            element: <ChangePhonePage />,
          },
          {
            path: 'success',
            element: <ChangePhoneSuccessPage />,
          },
        ],
      },
      {
        path: 'feedback',
        element: <FeedbackPage />,
      },
      {
        path: 'help',
        element: <HelpPage />,
      },
    ],
  },
];
